export default __webpack_public_path__ + "static/media/tokped.233504be.png";